import React from "react";
import { usregions, caregions } from "../../../utils/constants";

function RegionSelect({
  defaultOptionLabel = "Select Region",
  country,
  region,
  setRegion,
  keyField,
  formik,
  label,
  required = true,
  hideOptional = false,
  disabled = false,
  readOnly = false,
}) {

  const selectedCountry = country || formik?.values?.["country"];
  let currentRegion = region || formik?.values?.[keyField] || "";

  if (currentRegion && !currentRegion.includes("-") && selectedCountry) {
    currentRegion = `${selectedCountry}-${currentRegion}`;
  }
  const handleChange = (e) => {
    const val = e.target.value;
    setRegion && setRegion(val);
    formik.setFieldValue(keyField, val);
  };

  // choose region list based on country
  let regions = [];
  if (selectedCountry === "US") regions = usregions;
  if (selectedCountry === "CA") regions = caregions;

  const isDisabled = disabled || readOnly || !selectedCountry;

  return (
    <div className="field-wrap">
      <label htmlFor={keyField}>
        {label}
        {required ? (
          <span style={{ color: "red" }}> *</span>
        ) : hideOptional ? (
          ""
        ) : (
          " (Optional)"
        )}
      </label>

      <select
        id={keyField}
        name={keyField}
        value={currentRegion}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        disabled={isDisabled}
        className="form-control"
        style={{ cursor: readOnly ? "auto" : "pointer" }}
      >
        <option value="">{defaultOptionLabel}</option>

        {regions.map((r) => (
          <option key={r.value} value={r.value}>
            {r.name}
          </option>
        ))}
      </select>

      {formik?.touched[keyField] && formik?.errors[keyField] && (
        <div className="error-text">{formik?.errors[keyField]}</div>
      )}
    </div>
  );
}

export default RegionSelect;
